import React, { useEffect, useLayoutEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AwsAuthService from '../../../services/aws-auth-service';
import { updateLoggedIn } from '../../../modules/user';
import { AppDispatch } from '../../../store';
import urls from '../../../utils/urls';
import { updateStylePattern } from '../../../modules/pattern';
import { RootState } from '../../../rootReducer';
import specialmoveSlice from '../../../modules/specialmove';

type ErrorLocation = {
  message?: string,
  code?: string,
}

// Z001
const Error: React.FC = () => {
  const location = useLocation<ErrorLocation>();
  const dispatch: AppDispatch = useDispatch();
  const { stylePattren } = useSelector((state: RootState) => state.pattern);
  const { clearAllSpecialmove } = specialmoveSlice.actions;

  useLayoutEffect(() => {
    if (stylePattren !== 'A') {
      dispatch(updateStylePattern('A'));
    }
  }, []);

  useEffect(() => {
    if (['5000', '4011'].includes(location.state?.code || '')) {
      AwsAuthService.signOut();
      dispatch(updateLoggedIn(false));
      sessionStorage.clear();
      localStorage.clear();
    }
    dispatch(clearAllSpecialmove());
  }, []);

  const generateMessage = () => {
    if (!location.state?.message) return null;
    const texts = location.state?.message.split(/(\\n)/).map((item, index) => {
      const key = index.toString();
      return (
        <React.Fragment key={key}>
          {item.match(/\\n/) ? <br /> : item}
        </React.Fragment>
      );
    });
    return <>{texts}</>;
  };

  return (
    <main className="l-main">
      <section>
        <div className="blockMain mb05gd">
          <div className="blockNarrow">
            <div className="ttlH1 mtFLAT mbFLAT">
              <h1>エラー</h1>
            </div>
          </div>
        </div>
        <div className="blockSub mb05gd">
          <div className="blockNarrow">
            <div className="card mbXL">
              <p className="mtFLAT mbFLAT">
                {generateMessage()}
              </p>
            </div>
            <div className="mbFLAT flexC">
              <Link to={urls.TOP} className="btn btn--iconLeft">
                <span className="btn--iconLeft__inner">
                  <span className="btn--icon__icon">
                    <img src="/img/A/icon_home.png" width="26" alt="会員ホームへ" className="btn--icon__img" />
                  </span>
                  <span className="btn--icon__text">会員ホームへ</span>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Error;
